import { FC, useEffect, useState } from 'react'
import ResultApi from '../../../../infrastructure/api/ResultApi'
import { KTSVG } from '../../../../_metronic/helpers'
import { Modal } from 'react-bootstrap'
import { useFormik } from 'formik'
import {
  IResultModel,
  resultInitValues,
} from '../../../../models/responses/ResultModel'
import { IResultRequestModel } from '../../../../models/requests/ResultRequestModel'
import { ResultFormValidations } from '../../../validations/ResultFormValidations'
import { FormikValidationError } from '../../../components/validations/FormikValidationError'
import Select from 'react-select'
import { SaveChangesButton } from '../../../components/buttons/SaveChangesButton'
import { customSelectStyles } from '../../../helpers/ReactSelectHelper'
import { SelectModel } from '../../../models/SelectModel'
import { LanguageEnum } from '../../../../enums/LanguageEnum'
import { EnumToList } from '../../../helpers/EnumHelper'

type Props = {
  itemId: string
  show: boolean
  handleClose: () => void
}

const ResultFormModal: FC<Props> = ({ itemId, show, handleClose }) => {
  const [loading, setLoading] = useState(false)
  const [complete, setComplete] = useState(false)
  const languages = EnumToList(LanguageEnum)
  const [selectedLanguage, setSelectedLanguage] = useState<SelectModel>()
  const [result, setResult] = useState<IResultModel>(resultInitValues)

  const updateResult = (fieldsToUpdate: Partial<IResultModel>) => {
    const updatedData = { ...result, ...fieldsToUpdate }
    setResult(updatedData)
  }

  const formik = useFormik<IResultModel>({
    initialValues: result,
    enableReinitialize: true,
    validationSchema: ResultFormValidations,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setTimeout(async () => {
        let model: IResultRequestModel = {
          id: values.id,
          title: ''
        }
        process(model)
      }, 500)
    },
  })

  async function process(model: IResultRequestModel) {
    try {
      var result = undefined
      if (model.id === undefined || model.id === '')
        result = undefined
      else {
        result = await ResultApi.UpdateResult(model)
      }
      formik.resetForm()
      handleClose()
    } catch (error) {
      alert('Error: ' + error)
      setLoading(false)
    }
    setLoading(false)
  }

  async function init() {
    let result: IResultModel
    if (itemId !== '') {
      var response = await ResultApi.GetResult(itemId)
      result = response.data
    } else {
      result = resultInitValues
    }
    setResult(result)
  }

  useEffect(() => {
    formik.resetForm()
    if (show) init()
  }, [itemId, show])

  const handleChangeLanguage = (e: any) => {
    setSelectedLanguage(e)
  }

  return (
    <Modal
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-600px h-auto'
      show={show}
      onHide={handleClose}
    >
      <form className='form w-100' onSubmit={formik.handleSubmit} noValidate>
        <div className='modal-content'>
          <div className='modal-header pb-0 border-0 justify-content-end'>
            <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
              <KTSVG path='/media/icons/duotone/Navigation/Close.svg' className='svg-icon-1' />
            </div>
          </div>
          <div className='modal-body mx-5 mx-xl-18 pt-0 pb-15'>
            <div className='text-center mb-13'>
              <h1 className='mb-3'>{itemId === '' ? 'Add' : 'Edit'} Result</h1>
              <div className='text-muted fw-bold fs-5'>
                Exam Management <small>Educall</small>
              </div>
            </div>
            <div className='mb-10'>
              <label className='form-label fw-bolder required'>Title</label>
              <input
                {...formik.getFieldProps('examTitle')}
                type='text'
                name='examTitle'
                className='form-control form-control-solid'
                placeholder='Entry..'
              />
              <FormikValidationError touched={formik.touched.title} error={formik.errors.title} />
            </div>

          </div>
          <div className='modal-footer'>
            <div className='d-flex flex-center '>
              <SaveChangesButton
                loading={loading}
                setLoading={setLoading}
                complete={complete}
                setComplete={setComplete}
                valid={formik.isValid}
                submit={formik.isSubmitting}
                setSubmit={formik.submitForm}
              />
            </div>
          </div>
        </div>
      </form>
    </Modal>
  )
}

export { ResultFormModal }
